<div class="modal-content">
  <div class="content">
    <div class="text-right">
      <mat-icon mat-dialog-close class="close-button">close</mat-icon>
    </div>
    <h2>{{ data.vessel_name }} Deviation</h2>

    <div class="popup-info">
      <p><b>Route:</b> {{ data.from }} → {{ data.to }}</p>
      <p>
        <b>Deviation:</b> {{ data.deviation_distance | number: "1.0-2" }} nm
      </p>
      <p><b>Allowed Deviation Limit:</b> {{ data.deviation_value }} nm</p>
    </div>

    <div id="map" style="height: 300px"></div>
    <div mat-dialog-actions class="dialog-actions">
      <button class="btn btn-light hover-clear clear" (click)="goToFleet()">
        Go To Vessel View
      </button>
      <button
        class="btn btn-light hover-clear clear"
        (click)="resetAlerts(data.imo)"
        matTooltip="Snooze the alerts for 8 hours"
        matTooltipPosition="above"
      >
        Reset Alerts
      </button>
    </div>
  </div>
</div>
